export default __webpack_public_path__ + "static/media/B0003.90fd3098.png";